import React from "react";
import './footer.css';

function Footer(){
    return(
        <div className = "footerContainer" scroll = "no">
            <div className="footerText">
                <p className="copyText"> <strong>Copyright</strong> ©2020 Projet React | Soliman .A | Robin .B | Chris .F | Valentin .H | Patxi .M | Grégoire .R |</p>
            </div>
        </div>
    );
}
export default Footer;